import PropTypes from 'prop-types'
import { Icon } from '@moneymade/moneymade-ui'

import { addFavoriteCall, deleteFavoriteCall } from 'api/calls'
import styles from './PlatformFavorite.module.scss'

const PlatformFavorite = ({
  className,
  compact,
  textBefore,
  textAfter,
  platformId,
  isLogged,
  favoritePlatforms,
  token,
  handleSetUserField,
  handleAddInvestmentToFavorites,
  handleAddInvestmentsToFavorites,
  handleRemoveInvestmentFromFavorites
}) => {
  // Check for current investment in the favorites
  const handleIsStarActive = () => favoritePlatforms.some(inv => inv === platformId)

  const handleAddFavorite = async () => {
    // Add immediate to the redux store
    handleAddInvestmentToFavorites(platformId)
    // Call to add
    const { success, result } = await addFavoriteCall(token, { platform: platformId })()
    // Update the redux store if call unsuccess to prevent fake action
    if (!success) handleAddInvestmentsToFavorites(result?.platforms || [])
  }

  const handleDeleteFavorite = async () => {
    // Remove immediate from the redux store
    handleRemoveInvestmentFromFavorites(platformId)
    // Call to remove
    const { success, result } = await deleteFavoriteCall(token, { platform: platformId })()
    // Update the redux store if call unsuccess to prevent fake action
    if (!success) handleAddInvestmentsToFavorites(result?.platforms || [])
  }

  const handleFavoritesClick = event => {
    event.preventDefault()
    event.stopPropagation()
    // Shjow auth modal if user is not logged else add/remove favorite

    if (!isLogged) {
      handleSetUserField({ key: 'isAuthModal', value: true })
    } else if (handleIsStarActive()) {
      handleDeleteFavorite()
    } else {
      handleAddFavorite()
    }
  }

  return (
    <button
      type="button"
      onClick={handleFavoritesClick}
      className={`${className} ${compact ? styles.Compact : styles.Expand} ${
        handleIsStarActive() ? `checked ${styles.Checked}` : `unchecked ${styles.Unchecked}`
      }`}
    >
      {textAfter ? <span>{textAfter}</span> : null}
      <Icon icon={handleIsStarActive() ? 'icon-heart-filled' : 'icon-heart'} />
      {textBefore ? <span>{textBefore}</span> : null}
    </button>
  )
}

PlatformFavorite.propTypes = {
  className: PropTypes.string,
  compact: PropTypes.bool,
  textBefore: PropTypes.string,
  textAfter: PropTypes.string,
  platformId: PropTypes.string,
  isLogged: PropTypes.bool,
  favoritePlatforms: PropTypes.arrayOf(PropTypes.string),
  token: PropTypes.string,
  handleSetUserField: PropTypes.func,
  handleAddInvestmentToFavorites: PropTypes.func,
  handleAddInvestmentsToFavorites: PropTypes.func,
  handleRemoveInvestmentFromFavorites: PropTypes.func
}

PlatformFavorite.defaultProps = {
  className: '',
  compact: true,
  textBefore: '',
  textAfter: '',
  platformId: '',
  isLogged: false,
  favoritePlatforms: {},
  token: '',
  handleSetUserField: () => {},
  handleAddInvestmentToFavorites: () => {},
  handleAddInvestmentsToFavorites: () => {},
  handleRemoveInvestmentFromFavorites: () => {}
}

export default PlatformFavorite
